import type { ReactNode } from 'react';

export const UserPageHeader = ({ title, description }: { title: ReactNode; description?: ReactNode }) => {
  return (
    <div className="user-page-header">
      <h1 className="vp-title-m">
        {title}
      </h1>
      {description && (
        <p className="vp-body-m profile__subtitle">
          {description}
        </p>
      )}
    </div>
  );
};
